<template lang="pug">
  .container(id="DurationInput-container")
    el-input.input(
      id="DurationInput-hoursInput",
      @change='updateDuration()',
      v-model='hours',
      type='text',
      size='mini',
      v-mask="'###'",
      :disabled='disabled'
    )
    span.label :
    el-input.input(
      id="DurationInput-minutesInput",
      @change='updateDuration()',
      v-model='minutes',
      type='text',
      size='mini',
      v-mask="'###'",
      :disabled='disabled'
    )
    span.label :
    el-input.input(
      id="DurationInput-secondsInput",
      @change='updateDuration()',
      v-model='seconds',
      type='text',
      size='mini',
      v-mask="'##'",
      :disabled='disabled'
    )
    span.label.label-milliseconds .
    el-input.input.input-milliseconds(
      id="DurationInput-milisecondsInput",
      @change='updateDuration()',
      v-model='milliseconds',
      type='text',
      size='mini',
      v-mask="'###'",
      :disabled='disabled'
    )
    span.label
</template>
<script>

export default {
  components: {
  },
  created () {
  },
  props: {
    'durationMs': {
      required: true
    },
    'size': {
      required: false
    },
    'disabled': {
      required: false
    }
  },
  mixins: [
  ],
  data () {
    return {
      errors: {
      },
      hours: parseInt(this.msToDurationWithHours(this.durationMs)[0]),
      minutes: parseInt(this.msToDurationWithHours(this.durationMs)[1]),
      seconds: parseInt(this.msToDurationWithHours(this.durationMs)[2]),
      milliseconds: parseInt(this.msToDurationWithHours(this.durationMs)[3])
    }
  },
  methods: {
    updateDuration () {
      this.hours = parseInt(this.hours)
      this.minutes = parseInt(this.minutes)
      this.seconds = parseInt(this.seconds)
      this.milliseconds = parseInt(this.milliseconds)
      // if (this.minutes > 59) {
      //   this.minutes = this.minutes - 60
      //   this.hours = this.hours + 1
      // }
      if (this.seconds > 59) {
        this.seconds = this.seconds - 60
        this.minutes = this.minutes + 1
      }
      this.$emit('durationUpdated',
        this.hours * 60 * 60 * 1000 +
        this.minutes * 60 * 1000 +
        this.seconds * 1000 +
        this.milliseconds
      )
    },
    msToDuration (durationMilliseconds) {
      let milliseconds = parseInt(durationMilliseconds % 1000)
      let seconds = parseInt((durationMilliseconds / 1000) % 60)
      let minutes = parseInt(durationMilliseconds / (1000 * 60))
      return [minutes, seconds, milliseconds]
    },
    msToDurationWithHours (durationMilliseconds) {
      let milliseconds = parseInt(durationMilliseconds % 1000)
      let seconds = parseInt((durationMilliseconds / 1000) % 60)
      let minutes = parseInt(durationMilliseconds / (1000 * 60))
      let hours = (minutes / 60)
      let rhours = Math.floor(hours)
      minutes = (hours - rhours) * 60
      let rminutes = Math.round(minutes)
      return [this.zeroPad(rhours, 2), this.zeroPad(rminutes, 2), this.zeroPad(seconds, 2), this.zeroPad(milliseconds, 3)]
    },
    zeroPad (num, places) {
      return String(num).padStart(places, '0')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container {
    display: flex;
    align-items: center;
    .input {
      width: 45px;
      height: 30px;
      &.input-milliseconds {
        width: 55px;
      }
    }
  }
  .label {
    &.label-milliseconds {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/DurationInput.vue